export default __webpack_public_path__ + "static/media/crm.96c67f47.svg";